import React from 'react';
import { Row, Col, Input } from 'reactstrap';
import CommonFunctions from '../RegCommon/CommonFunctions';
import RegItemContainer from './RegItemContainer';

var moment = require('moment-timezone');

class RegOptionsSection extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            formtype: this.props.formtype,
            groupid: this.props.groupid,
            groupname: ''
        }
        this.refreshComponent = this.refreshComponent.bind(this);
    }

    refreshComponent() {
        this.props.refreshComponent();
    }
    render() {
       //console.log("regoptions section")
        var groupTitle = this.getGroupTitle()
        // var total = 0

        if (this.isSectionEnabled()) {
            return (
                <div>
                    <h4 className="reg-option-section" style={global.$registrationform.styles.regoptions.groupheader}>{groupTitle}
                        {/* <p className="section-total"><div dangerouslySetInnerHTML={{ __html: total }}></div></p> */}
                    </h4>

                    {this.renderSectionDesc()}
                    {this.renderRegItemColumnHeaders()}
                    {this.renderRegItemContainer()}
                    <br />

                </div>
            )
        }
        else {
            return <div></div>
        }
    }

    /*
        config.json:
        "groupnames": "names#:one:Booth Choice;three:Additional Sponsor Options;four:Specialty Booths;five:Additional Representative Badges",
        "grouptitles": "titles#:one:Booth Choice;three:Additional Sponsorship Options;four:Specialty Booths;five:Additional Representative(s)/Attendee(s)",
    */

    isSectionEnabled() {
       //console.log(global.$registrationform.setup[this.state.formtype]);
        var groupnames = global.$registrationform.setup[this.state.formtype].groupnames;
        var groupname = CommonFunctions.getValueFromMeCard(groupnames, this.state.groupid);
       //console.log(groupname)
        if (groupname == '') {
            return false
        }
        else {
            this.state.groupname = groupname;
            return true
        }
    }

    getGroupTitle() {
        var grouptitles = global.$registrationform.setup[this.state.formtype].grouptitles;
        var title = CommonFunctions.getValueFromMeCard(grouptitles, this.state.groupid);
        return title
    }

    renderSectionDesc() {

        var sectionid = CommonFunctions.covertGroupIDToSectionID(this.state.groupid)
        var tagname = sectionid + 'desc'

        //console.log('renderSectionDesc tagname = ' + tagname)

        var cfg = global.$registrationform.setup[this.state.formtype];
        var description = cfg[tagname]

        return (
            <div dangerouslySetInnerHTML={{ __html: description }}></div>
        )
    }

    renderRegItemColumnHeaders() {

        var headers = global.$registrationform.setup[this.state.formtype].headers;
        var header1 = CommonFunctions.getValueFromMeCard(headers, 'header1');
        var header2 = CommonFunctions.getValueFromMeCard(headers, 'header2');
        var header3 = CommonFunctions.getValueFromMeCard(headers, 'header3');

        return (
            <Row className="reg-options-table-header" style={global.$registrationform.styles.regoptions.tableheaders}>
                <Col md={6}><b>{header1}</b></Col>
                <Col md={3}><b>{header2}</b></Col>
                <Col md={3} className="reg-options-table-header3"><b>{header3}</b></Col>
            </Row>
        )
    }
    renderRegItemContainer() {
        // Get all the regitems for the current group
       //console.log(global.$regitems)
        var groupregitems = CommonFunctions.getRegItemsForGroup(this.state.groupname);
       //console.log(groupregitems);

        return groupregitems.map(regitem => {
            return (
                <RegItemContainer key={regitem.data5} regitem={regitem} itemid={regitem.data5} groupname={this.state.groupname} formtype={this.props.formtype} refreshComponent={this.refreshComponent}/>
            )
        })
    }
}

export default RegOptionsSection;